require("../../shared/v2/assets/css/base.css");
require("../../shared/v2/assets/css/site-nav-footer.less");
require("../../caravancampingsales/v2/assets/css/site-nav.css");
require("../../caravancampingsales/v2/assets/css/site-nav-footer.less");
require("../../shared/v2/assets/css/nav-network.css");
require("../../shared/v2/assets/css/nav-nonmember.css");
require("../../shared/v2/assets/css/nav-membership.css");

require("../../shared/v2/assets/js/newsletter.js");

require("../../../../Content/js/menus.js");
require("../../../../Content/js/csn_returnurl.js");
require("../../../../Content/js/dropdowns.js");



// WEBPACK FOOTER //
// ./Views/Sites/caravancampingsales/v2/caravancampingsales-v2-assets.js